var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"title":"Edit","variant":"warning","size":"sm"},on:{"click":_vm.handleClick}},[_c('feather-icon',{attrs:{"icon":"EditIcon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }